<template>
  <table class="asd-table">
    <thead>
      <tr class="table-heading">
        <th></th>
        <th>
          {{ $t('common.name') }}
        </th>
        <th>
          Obsahuje vlastnosti
        </th>
      </tr>
    </thead>
    <tbody>
      <ResourceTypeRow
        v-for="resourceType in projectTypes"
        :key="resourceType.id"
        :resourceTypeId="resourceType.id"
      ></ResourceTypeRow>
    </tbody>
  </table>
</template>

<script>
import ResourceTypeRow from 'CORE/components/resource/type/row'
import { czSorter } from 'CORE/utils/sorters'
import _ from 'lodash'

export default {
    name: 'ResourceTypeTable',
    components: {
        ResourceTypeRow,
    },
    computed: {
        projectTypes() {
            return _.sortWith(
                this.$store.getters.resourceTypes,
                (a, b) => czSorter('asc')(...[a, b].map(c => _.get(c, 'name')))
            )
        },
    },
}
</script>
